<div class="rv-center my-medium">
  <logo></logo>
</div>
<div class="rv-rows large">
  <div class="rv-title-05 bold">Request submitted!</div>
  <div class="body-paragraph">
    If an account exists for {{ _.email }}, you will receive an email with
    instructions on how to reset your password.
  </div>
  <button
    rivButton
    variant="primary"
    [full]="true"
    size="xlarge"
    routerLink="/login"
    [queryParams]="{ email: _.email }"
  >
    Go to login
  </button>
</div>
<div *ngIf="!_.envIsZelis" class="rv-explanation my-small rv-center">
  Need help? <a class="rv-link" (click)="openIntercom()">Contact support.</a>
</div>
